import React from 'react';
import EventMg from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';

/**
 * 施工体制ページング用のコンポーネント
 *
 * @props {number} page: 現在表示中のページ番号
 * @props {number} lastPage: 最終ページ番号
 */
export default class FieldTreePagination extends React.Component {
  constructor(props) {
    super(props);
  }

  isFirstPage = () => {
    return this.props.page <= 1;
  };

  isLastPage = () => {
    return this.props.page >= this.props.lastPage;
  };

  prevButtonClassName = () => {
    return this.isFirstPage()
      ? 'prev-button pagination-button'
      : 'prev-button pagination-button active';
  };

  nextButtonClassName = () => {
    return this.isLastPage()
      ? 'next-button pagination-button'
      : 'next-button pagination-button active';
  };

  render() {
    return (
      <div className='fieldtree__pagination'>
        <span className='pagination-label'>
          {this.props.page}ページ目 / 全{this.props.lastPage}ページ中
        </span>
        <div className='pagination-buttons'>
          <div
            className={this.prevButtonClassName()}
            disabled={this.isFirstPage()}
            onClick={() => {
              if (!this.isFirstPage()) {
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_PAGINATION_DOWN);
              }
            }}
          >
            <span className='arrow' />
            前のページへ
          </div>
          <label> | </label>
          <div
            className={this.nextButtonClassName()}
            onClick={() => {
              if (!this.isLastPage()) {
                EventMg.trigger(FIELD_TREE_EVENTS.TREE_PAGINATION_UP);
              }
            }}
          >
            次のページへ
            <span className='arrow' />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldTreePagination.jsx